export default __webpack_public_path__ + "static/media/Aqeel_Profile.1bcb333c.jpeg";